let _primaryColorOverride: string | null = null;

export function setBrandingPrimaryColor(color: string | null) {
  _primaryColorOverride = color;
}

export function getBrandingPrimaryColor(): string | null {
  return _primaryColorOverride;
}
